// extracted by mini-css-extract-plugin
module.exports = {"item":"_1VCViuqK8UOFJnI_8vBkh3","heading":"_1OlSVNpHw_1XmyFhLJ6m5m","body":"_3CPAaaVqvLeRrAGXYoYxjY","button":"_245xN7VH7MF5-oJw8UtCVI"};